<template>
  <vs-row vs-type="flex" vs-w="12">
    <branch-transfers v-if="!$isCenterBranch() && !$isRegionalCenterBranch()" @reload="getTransferList"/>
    <new-transfer v-if="$isRegionalCenterBranch()" ref="newTransfer" @reload="getList" />
    <vs-row v-if="$isCenterBranch() || $isRegionalCenterBranch()" vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" class="mb-1">
        <global-filter ref="filterer" :tableOptions="tableOptions" :filterOptions="filterOptions"
                       :filterChips="filterChips" :filterOptionNames="filterOptionNames" :isActive="isFilterActive"
                       @saveOptions="saveOptions" @close="isFilterActive = false;"/>
        <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12">
          <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="$isRegionalCenterBranch()" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Stok Transfer" position="top">
                    <vs-button
                      @click="openNewTransfer"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    />
                  </vx-tooltip>
                </vs-col>
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Detaylı Filtereleme" position="top">
                  <vs-button @click="isFilterActive = !isFilterActive;"
                             class="panel-action text-warning xlarge-button panel-action-box-shadow" color="transparent"
                             icon-pack="pickicon" icon="icon-pick-filter">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Excel Export" position="top">
                  <vs-button @click="getExcel" class="panel-action text-warning xlarge-button panel-action-box-shadow"
                             color="transparent" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col id="filter-chips" vs-type="flex" class="ml-16">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
              <vs-button id="clearFilterButton" v-if="filterChips.length > 0" @click="clearFilter"
                         class="mr-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather" icon="icon-slash"
                         radius
                         color="transparent"/>
              <vs-col vs-type="flex" class="w-auto" v-for="(chip,index) in filterChips" :key="index">
                <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col,index)"
                         v-show="chip.value != '' " closable>
                  <vs-row vs-tpye="flex" vs-w="12">
                    <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + ' :' }}
                        </span>
                    </vs-col>
                    <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                        <span class="weight-600 italic text-xsmaller text-primary">
                          {{ chip.value }}
                        </span>
                    </vs-col>
                  </vs-row>
                </vs-chip>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
      <vs-row class="transferList mt-4" vs-type="flex" vs-w="12">
        <vs-row class="transferListHeader" vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="4" class="px-1">
            <span class="text-primary text-small bold">
              Şube
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" class="px-1">
            <span class="text-primary text-small bold">
              Son Sayım Tarihi
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" class="px-1">
            <span class="text-primary text-small bold">
              Durum
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="transferListEntries" vs-type="flex" vs-w="12">
          <vs-row class="transferListEntry" vs-type="flex" vs-w="12" v-for="(transfer,index) in transfers"
                  :key="index" @click="selected = transfer">
            <div class="w-full d-flex pointer" @click="selected = transfer">
              <vs-col vs-type="flex" vs-w="4" class="px-1">
                <span class="text-dark weight-600 text-smaller">
                  {{ transfer.branch.name }}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="4" class="px-1" vs-align="center">
                <span class="text-dark weight-500 text-smaller">
                  {{ transfer.created }}
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="4" class="px-1" vs-align="center">
                <span
                  :class="{ 'text-danger': transfer.status === 1 || transfer.status === 4, 'text-warning': transfer.status === 2, 'text-success': transfer.status === 0 || transfer.status === 3 }"
                  class="text-success weight-600 text-smaller">
                  {{ stockTransferStatuses.find(x => x.id === transfer.status).name }}
                </span>
              </vs-col>
            </div>
          </vs-row>
        </vs-row>
      </vs-row>
    </vs-row>
    <vs-popup background-color="#f8f8f8" v-if="$isCenterBranch() || $isRegionalCenterBranch()" fullscreen :active.sync="isActiveBranchTransfers"
              id="branchTransfersPopup" v-esc="escapeBranchTransfers" title="Şube Transferleri">
      <branch-transfers ref="branchTransfers"/>
    </vs-popup>
  </vs-row>
</template>

<script>
import GlobalFilter from "@/views/pages/GlobalFilter";
import BranchTransfers from "@/views/pages/MonthlyStockTransfer/BranchTransfers";
import TransferReviewer from "./TransferReviewer.vue";
import {
  getTransferList,
  getTransferListForDealer,
  getTransferListExcel,
  getTransferListExcelForDealer
} from "@/api/MonthlyStockTransfer.js";
import NewTransfer from "./NewTransfer.vue";
import {getStockTransferStatuses} from "@/model/constants/stockTransferStatuses";

export default {
  data() {
    return {
      stockTransferStatuses: getStockTransferStatuses(),
      selected: null,
      branches: [],
      filteredTransfers: [],
      transfers: [],
      tableOptions: {},
      isActiveBranchTransfers: false,
      isFilterActive: false,
      filterOptions: ["branch", "month", "year"],
      filterOptionNames: ["Şube", "Ay", "Yıl"],
      filterChips: []
    }
  },
  components: {
    BranchTransfers,
    NewTransfer,
    TransferReviewer,
    GlobalFilter
  },
  methods: {
    escapeBranchTransfers() {
      if (this.isActiveBranchTransfers) this.isActiveBranchTransfers = false;
    },
    getExcel() {
      if (this.$isRegionalCenterBranch()) {
        getTransferListExcelForDealer(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Son Şube Stok Transferleri.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      } else {
        getTransferListExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Son Şube Stok Transferleri.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      }
      
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branch: this.$isCenterBranch() ? null : this.$currentUser.branch,
        month: null,
        year: null
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getTransferList: function () {
      if (this.$isRegionalCenterBranch()) {
        getTransferListForDealer(this.tableOptions).then(res => {
        if (res && res.status === 200) {
          this.transfers = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Transferler Yüklenemedi !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      });
      }else{
        getTransferList(this.tableOptions).then(res => {
        if (res && res.status === 200) {
          this.transfers = res.data;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Transferler Yüklenemedi !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      });
      }
      
    },
    openNewTransfer() {
      this.$refs.newTransfer.isActive = true;
    }
  },
  created() {
    if (this.$isCenterBranch() ||this.$isRegionalCenterBranch()) this.getTransferList()
    //if (this.$isCenterBranch()) this.getBranchNameList();
    // else {
    //   let month = this.$now.date().getMonth();
    //   if (month == 0) month = 12;
    //   this.tableOptions = {
    //     year: this.$now.date().getFullYear().toString(),
    //     month: this.$months().find(x => x.id == month),
    //   };
    // }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        if (val) {
          this.getTransferList();
        }
      }
    },
    selected(val) {
      if (!val || val.status === 4 || val.id <= 0) return;
      this.$refs.branchTransfers.tableOptions.branch = {
        id: val.branch.id
      }
      this.isActiveBranchTransfers = true;
      this.selected = null;
    }
  }
}

</script>

<style>
#branchTransfersPopup .vs-popup {
  background-color: unset !important;
}

.transferReportOptions .vs__selected {
  color: rgba(var(--vs-primary), 1) !important;
}

.transferReportOptions .vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  width: fit-content !important;
}

.transferReportOptions .vs__dropdown-toggle {
  border: none !important;
  border-bottom: 1px solid #00000035 !important;
  border-radius: 0;
}

.transferBranchSelect {
  min-width: 221px;
}

.transferMonthSelect {
  min-width: 100px;
}

.transferYearSelect {
  min-width: 90px;
}

.transferListEntry {
  padding-top: .5rem;
  padding-bottom: .5rem;
  border-bottom: 1px solid #00000030;
}

.transferListEntry:hover {
  border: 1px solid rgba(var(--vs-primary), 1);
}

.transferListHeader {
  border-bottom: 1px solid #00000030;
}

</style>
